<template>
  <LoadingState v-if="isLoading()" :size="50" />
  <ErrorState v-else-if="isErrored()" />
  <div v-else-if="site">
    <SecureShell :plan="getPlan()" :resource-name="getResourceName()" :site="site" class="mb-4" />
    <FtpSslTable :resource-name="getResourceName()" :site="site" class="mb-4" />
    <PasswordProtection
      v-if="showPasswordProtection()"
      :resource-name="getResourceName()"
      :site="site"
    />
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import ErrorState from "@/components/display/ErrorState";
import FtpSslTable from "@/components/smart/tables/FtpSslTable";
import LoadingState from "@/components/display/LoadingState";
import PasswordProtection from "@/components/smart/cards/PasswordProtection";
import SecureShell from "@/components/smart/cards/SecureShell";
import store from "@/store";

export default {
  name: "SiteAccessPage",
  components: {
    ErrorState,
    FtpSslTable,
    LoadingState,
    SecureShell,
    PasswordProtection,
  },
  setup() {
    const site = computed(() => store.getters["sites/getItem"]);
    const siteStatus = computed(() => store.getters["sites/getItemStatus"]);

    const getPlan = () => site.value.plan;
    const getResourceName = () => site.value.domain;

    const showPasswordProtection = () => site.value?.app?.type !== "generic";

    const isErrored = () => siteStatus.value.isErrored;
    const isLoading = () => siteStatus.value.isLoading;

    return {
      getPlan,
      getResourceName,
      isErrored,
      isLoading,
      showPasswordProtection,
      site,
    };
  },
};
</script>
